import { merge as _merge } from 'lodash'
import zh_cn from 'core/translations/zh_simplified'

export default _merge(zh_cn, {
  serverError: {
    INVALID_SERIAL: '代码无效：必须为18位数字。',
    PRODUCTION_ORDER_NOT_FOUND: '找不到此代码对应的生产订单。',
    STYLE_MATERIAL_COLOR_MISMATCH: '商品的型号、部件或颜色与生产订单行不符。',
    SCONNECT_SHIPMENT_FAILED: '向S-Connect发送发货失败。'
  },
  otb_outbound: {
    scan_title: '扫描生产订单代码（18位）',
    scan_code_label: '代码',
    select_title: '选择生产订单',
    header_label: '生产订单',
    pdf_title: 'PDF标签',
    pdf_downloaded: '包裹标签已下载',
    pdf_error: '无法生成或下载PDF标签',
    pdf_parcel_unavailable: '包裹已确认，但无法获取以下载PDF标签'
  }
})
